import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { ImplementationPackage } from './BillingTypes';
import { formatPriceOnUserLocale } from './functions/billingUtils';
import '../../../style/scss/billing.scss';

interface ImplementationRowCardProps {
    implementationPackage: ImplementationPackage;
    selected?: boolean;
    onClick?: () => void;
};

const ImplementationRowCard: React.FC<ImplementationRowCardProps> = ({ implementationPackage, selected, onClick }) => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    return (
        <div className={`module-row-card ${selected ? 'selected' : ''} ${onClick ? 'clickable' : ''}`}
             onClick={onClick}>
            {implementationPackage.image && (
                <div className='module-image'>
                    <img src={implementationPackage.image} alt={implementationPackage.name} />
                </div>
            )}
            <div className='module-info'>
                <h5>{implementationPackage.name}</h5>
                {implementationPackage.description && (
                    <p>{implementationPackage.description}</p>
                )}
            </div>
            <div className='module-price'>
                <div className='price-label'>
                    <span className='currency-icon'>€ </span>
                    {formatPriceOnUserLocale(parseFloat(implementationPackage.price), userLocale)}
                </div>
                <div className='price-unit-label'>
                    {t('billing.implementation_package.one_time_label')}
                </div>
            </div>
        </div>
    );
};

export default ImplementationRowCard;
